import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { payDeviceRetain, payDeviceRetain_currency } from "@/api/dataAll/payAccountRetain";
import * as echarts from "echarts";
export default {
  name: "payDeviceRetain",
  mixins: [tabulation],
  data: function data() {
    return {
      more: true,
      value1: "",
      value2: [],
      tableData: [],
      tableLtv: [],
      tableDate: "",
      pageData: {},
      show: false,
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      selectedArr: {},
      intReq: [],
      screen: [],
      PrimitiveDy: [],
      cellStylekeys: ["rem"]
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.kind = 1;
                reqFn = _this.currencyClose ? payDeviceRetain_currency : payDeviceRetain;

                _this.searchClickPoints(reqFn, 1);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      console.log(qres);
      var res = {
        data: {
          totalSum: 0,
          data: {},
          avgData: {},
          num: {}
        }
      };
      qres.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
        res.data.num = _objectSpread(_objectSpread({}, res.data.num), i.num);
        res.data.totalSum = res.data.totalSum + i.totalSum;

        for (var k in i.avgData) {
          var nums = i.num[i.searchdate.starttime][k] == '/' ? 0 : i.num[i.searchdate.starttime][k];
          res.data.avgData[k] = !res.data.avgData[k] ? nums : res.data.avgData[k] + nums;
        }
      });

      for (var i in res.data.avgData) {
        res.data.avgData[i] = (res.data.totalSum ? (res.data.avgData[i] / res.data.totalSum * 100).toFixed(2) : 0) + '%';
      }

      console.log(res); // if(this.currencyClose && !this.searchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }

      this.timeInterval();
      this.tableData = [];
      this.dates = [];
      this.series = [];

      for (var k in res.data.data) {
        this.dates.push(k);
        var d = {
          date: k // num:res.data.num[k]

        };
        var _i = [];

        for (var j in res.data.data[k]) {
          if (j.indexOf("pnum_") == -1) {
            _i.push(j);
          }
        }

        var o = {
          name: k,
          type: "line",
          data: [],
          smooth: true
        };

        for (var _j in res.data.data[k]) {
          if (_j.indexOf("pnum_") == -1) {
            d["rem" + _j] = this.zhuan([res.data.data[k][_j]])[0];
            o.data.push(d["rem" + _j]);

            if (this.Dynamic.length < _i.length) {
              var a = _j == 2 ? "次" : _j;
              this.Dynamic.push({
                label: a + "留.RR" + _j,
                prop: "rem" + _j,
                tableText: _j == 2 ? "RR".concat(_j, "A") : "RR".concat(_j),
                desc: _j == 2 ? "次日付费设备留存率" : ""
              });
            }
          }
        }

        if (!this.screen.length) {
          this.screen = this.Dynamic.map(function (item) {
            return item.prop;
          });
          this.PrimitiveDy = this.Dynamic;
        }

        this.screenControls();
        this.series.push(o);
        this.tableData.push(d); // 总计数据处理

        var total = {
          date: "加权平均留存" // num: res.data.totalSum,

        };

        for (var _k in res.data.avgData) {
          total["rem" + _k] = this.zhuan([res.data.avgData[_k]])[0];
        }

        this.tableData.push(total);
        this.$nextTick(function () {
          _this2.getTableRight();
        });
        this.getechart();
      }
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.Dynamic = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 50);
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("payDeviceRetainEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: "付费设备留存率(%)"
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.label;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: "日期",
        prop: "date"
      }].concat(_toConsumableArray(this.Dynamic));
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.Dynamic.forEach(function (item) {
        data.map(function (i) {
          i[item.prop] = i[item.prop] + "%";
        });
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};